export class PesagemFiltro {
    public cdPesagem: number;
    public cdMatriz: number;
    public cdFazenda: number;
}
